import React, { FC } from 'react';
import SectionContainer from '@common/components/SectionContainer';
import { useTranslations, TranslationKey } from '@lang';
import { StyledBody } from './SpaEntityError.styles';

type SpaEntityStickyBarProps = {
  errorMessage: TranslationKey;
  values: object;
};

export const SpaEntityError: FC<SpaEntityStickyBarProps> = ({ errorMessage, values }) => {
  const { t } = useTranslations();
  return (
    <SectionContainer>
      <StyledBody>{t(errorMessage, values)}</StyledBody>
    </SectionContainer>
  );
};
